import {
  SelectionList,
  type SelectionListChangeEvent,
} from '@dixa/lib-shared-habla';
import { useCallback } from 'react';

import type { ConversationsTableDensity } from '../../../../conversationsTable.types';
import type { UseConversationsTableLayoutResult } from '../../../../utils/useConversationsTableLayout';

import { ConversationsTablePreferencesDensityPreview } from './components/preview/conversationsTablePreferencesDensityPreview';
import styles from './conversationsTablePreferencesDensity.module.scss';

const densities: ReadonlyArray<{
  readonly density: ConversationsTableDensity;
  readonly label: string;
}> = [
  { density: 'default', label: 'Default' },
  { density: 'compact', label: 'Compact' },
];

export type ConversationsTablePreferencesDensityProps = {
  /** The user's saved layout of the table. */
  layout: UseConversationsTableLayoutResult;
};

/** A list that lets the user choose how much space the rows of the conversations table take up. */
export const ConversationsTablePreferencesDensity = ({
  layout,
}: ConversationsTablePreferencesDensityProps): JSX.Element => {
  const { density: selectedDensity, setDensity } = layout;

  const handleChange = useCallback(
    ({ selectedItem }: SelectionListChangeEvent<ConversationsTableDensity>) => {
      setDensity(selectedItem.value);
    },
    [setDensity],
  );

  return (
    <SelectionList selectedValues={[selectedDensity]} onChange={handleChange}>
      <SelectionList.Section title="Density">
        {densities.map(({ density, label }) => (
          <SelectionList.Item
            key={density}
            value={density}
            className={styles.item}
            contentClassName={styles.itemContent}
          >
            {label}
            <ConversationsTablePreferencesDensityPreview density={density} />
          </SelectionList.Item>
        ))}
      </SelectionList.Section>
    </SelectionList>
  );
};
